/* eslint-disable @next/next/no-img-element */
/**
 * /* eslint-disable @next/next/no-img-element
 *
 * @format
 */

import { Dropdown, Menu, Skeleton, Space } from 'antd'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useCookies } from 'react-cookie'

type UserInformationProps = {
  dataInfoCustomer?: Record<string, any>
  isLoadingDataInfoCustomer: boolean
}

const UserInformation = (props: UserInformationProps) => {
  const { dataInfoCustomer, isLoadingDataInfoCustomer } = props
  const router = useRouter()

  const [cookies, setCookie, removeCookie] = useCookies(['token'])

  const items = [
    {
      key: '3',
      label: '',
      icon: (
        <div key={3} className=" py-2 !bg-white hover:!bg-[#f5f5f5] duration-200">
          <div className="!text-[14px] font-semibold flex items-center gap-[1rem]">
            <img
              src={dataInfoCustomer?.customer?.profile_picture ?? '/image/svg/user.svg'}
              alt=""
              className={`w-[2rem] flex-shrink-0 h-[2rem] ${
                dataInfoCustomer?.customer?.profile_picture ? 'rounded-full' : ''
              }`}
            />{' '}
            <span className="whitespace-nowrap">
              {dataInfoCustomer?.customer?.firstname} {dataInfoCustomer?.customer?.lastname}
            </span>
          </div>
        </div>
      ),
    },
    {
      key: '1',
      label: '',
      icon: (
        <div key={1} className="flex gap-[1rem] py-2 !bg-white hover:!bg-[#f5f5f5] duration-200">
          <img
            src={'/image/identification.png'}
            alt=""
            className="w-[2rem] flex-shrink-0 h-[2rem] filter-green"
          />
          <Link href="/account">
            <span className="!text-[14px] whitespace-nowrap">Thông tin cá nhân</span>
          </Link>
        </div>
      ),
    },
    {
      key: '2',
      label: '',
      icon: (
        <div
          className="flex gap-[1rem] py-2 !bg-white hover:!bg-[#f5f5f5] duration-200 !text-[14px]"
          key={2}
          onClick={() => {
            localStorage.removeItem('token')
            removeCookie('token', { path: '/' })
            localStorage.removeItem('loginSocial')
            localStorage.removeItem('cartId')
            window.location.replace(`${window.location.origin}/login`)
          }}
        >
          <img
            src={'/image/logout.png'}
            alt="logout"
            className="w-[2rem] flex-shrink-0 h-[2rem] filter-green"
          />
          <span className="whitespace-nowrap">Đăng xuất</span>
        </div>
      ),
    },
  ]

  const menu = <Menu className="mt-6 mx-2" items={items}></Menu>

  if (isLoadingDataInfoCustomer) {
    return (
      <Link href="/login">
        <button className="icon-user min-w-[12px]">
          <div className="img max-w-xs">
            <Skeleton.Input active size={'small'} block={true} />
          </div>
        </button>
      </Link>
    )
  }

  return (
    <>
      {!!dataInfoCustomer?.customer ? (
        <div
          className="flex"
          onClick={() => {
            if (window.innerWidth > 1200) {
              router.push('/account')
            }
          }}
        >
          <Dropdown
            className="cursor-pointer justify-between w-full !gap-0 sm:!gap-4"
            overlay={menu}
            trigger={['hover']}
            placement="bottom"
            overlayClassName="drop-down-user"
          >
            <div className="flex items-center gap-2 sm:gap-4">
              <div className="icon-user min-w-[12px] flex-shrink-0">
                <div className="img max-md:w-[3.6rem] max-md:h-[3.6rem]">
                  <img
                    src={dataInfoCustomer?.customer?.profile_picture ?? '/image/svg/user.svg'}
                    alt=""
                    className={`w-full h-full md:w-[2rem] md:h-[2rem] ex ${
                      dataInfoCustomer?.customer?.profile_picture ? 'rounded-full' : ''
                    }`}
                  />
                </div>
              </div>
              {isLoadingDataInfoCustomer ? (
                <Skeleton.Input active size={'small'} block={true} />
              ) : (
                <span className="font-semibold hidden sm:flex overflow-hidden whitespace-nowrap">
                  {dataInfoCustomer?.customer?.firstname} {dataInfoCustomer?.customer?.lastname}
                </span>
              )}
            </div>
          </Dropdown>
        </div>
      ) : (
        <Link href="/login">
          <button className="icon-user min-w-[12px] max-md:bg-[#e7e5e5] max-md:rounded-full max-md:w-[3.6rem] max-md:h-[3.6rem] max-md:flex max-md:items-center max-md:justify-center ">
            <div className="img max-w-xs">
              <img
                src={dataInfoCustomer?.customer?.profile_picture ?? '/image/svg/user-login.svg'}
                alt=""
                className={`w-full h-full md:w-[2rem] md:h-[2rem] ex ${
                  dataInfoCustomer?.customer?.profile_picture ? 'rounded-full' : ''
                }`}
              />
            </div>
          </button>
        </Link>
      )}
    </>
  )
}

export default UserInformation
